import React, { useState, useEffect } from "react";
import { api } from "../../api";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";


const MerchantAgreementView = props => {


    const [agreeData, setAgreeData] = useState({});
    // eslint-disable-next-line
    const [isEditing, setIsEditing] = useState(false);
    const [formData, setFormData] = useState({
      territory: '',
      exclusive: '',
      minWallet: '',
      validityPeriod: '',
      rollForecast: '',
      additionalItem: ''
    });
    const token = useSelector((state) => state.auth.token);
    const { userType: role ,id} = useSelector((state) => state.auth.user);
    const [loadData, setloadData] = useState(true);


    

    const handleInputChange = (e) => {
      const { name, value } = e.target;
      setFormData({
        ...formData,
        [name]: value,
      });
    };
  

    useEffect(() => {
      if (loadData) {
        api.merchants
            .getMerchantAgreementView({ userId: id },token)
            .then((res) => {
                if (res.success === false) {
                    toast.error(res.message);
                }
                setAgreeData(res.data)
               
                setFormData(res.data)
                setloadData(false)
            })
            .catch((err) => {
                toast.error("Something went wrong");
                console.log(err)
            }
            );
       }
    }, [loadData,id,token])






    return (

        <div className="container-fluid">
            <div className="row">
                <div className="col-sm-12">
                    <div className="box-row">
                        <div className="table-head">
                            <h1 className="sec-header">VIEW AGREEMENT  </h1>
                        </div>
                        <div className="card">
                            <div className="card-body box-row">

                            <p className="MsoNormal" style={{ textAlign: 'center' }}>
                            <b style={{ fontWeight: 'normal' }}>
                                <u>
                                <span 
                                    lang="EN-US" 
                                    style={{
                                    fontSize: '12pt',
                                    lineHeight: '107%',
                                    fontFamily: '"Times New Roman",serif',
                                    msFareastFontFamily: '"Times New Roman"'
                                    }}
                                >
                                    RESELLER AGREEMENT TERMS AND CONDITIONS
                                    <span className="o:p"></span>
                                </span>
                                </u>
                            </b>
                            </p>

                           
                           
                                
                                <p style={{fontSize: '10pt',marginTop:'20px'}}>
                                By signing up on <a href="https://www.nodw.in/register" target="_blank" rel="noopener noreferrer" style={{ color: 'blue', textDecoration: 'none'}}> https://www.nodw.in/register</a>  (the “Platform”) through the online registration form (“Online Form”), NODWIN Gaming Pvt. Ltd. including its affiliates and/or sister concerns (“NODWIN”) hereby appoints You as a non-exclusive reseller of the Product(s) to customers, end users and consumers (“Customers”) and/or other online or physical retailers that purchase the Product for resale to Customers (“Retailers”) located in Territory during the Term solely in accordance with the terms and conditions herein below and You agree and accept the appointment. For the sake of clarity, You shall hereinafter be referred to as a “Reseller”. These terms and conditions (the "Agreement") govern the purchase of physical products, digital voucher codes and epins (the "Product") availed from different brands and/or game publishers (“Brand”) more specifically laid down in the Online Form by the Reseller from the Platform. Accordingly, the Reseller shall, during the Term, fully comply with the terms and conditions of the Agreement provided herein below. NODWIN and the Reseller shall hereinafter be referred to as a “Party” each individually and as “Parties” collectively.
                              
                                </p>

                            
                                <h4 style={{marginTop:'20px',fontSize:'16px'}}>
                               A) Appointment and Relationship.
                                 
                                </h4>

                                <ol  style={{fontSize: '10pt',marginTop:'10px'}}>
                                    <li>NODWIN may in its sole discretion, sell the Product to any other person, including retailers and customers in and outside the Territory.  By accepting this appointment, Reseller agrees to conform to all quality standards established from time to time by NODWIN for its resellers. The appointment of the Reseller shall always be on a non-exclusive basis, unless otherwise specifically laid down in the Online Form.</li>

                                    <li>Reseller shall not, without the prior written consent of NODWIN (emails permitted), appoint any sub-distributor or other person or entity to sell or distribute the Product; or sell the Product to any person or entity who Reseller knows or has reason to believe is purchasing the Product for resale, other than at retail, to Customers.</li>

                                    <li>This Agreement does not preclude either Party from entering into an agreement with any other person related to the sale or distribution of other goods or products, including those that are similar to or competitive with the Product.</li>
                                </ol>

                                <h4 style={{marginTop:'20px',fontSize:'16px'}}>
                                B) No Franchise or Business Opportunity Agreement.  
                                 
                                </h4>

                                <ol  style={{fontSize: '10pt',marginTop:'10px'}}>
                                    <li>The Parties to this Agreement are independent contractors and nothing in this Agreement shall be deemed or construed as creating a joint venture, partnership, agency relationship, franchise or business opportunity between NODWIN and Reseller. Neither Party, by virtue of this Agreement, will have any right, power or authority to act or create an obligation, express or implied, on behalf of the other Party. Each Party assumes responsibility for the actions of their personnel under this Agreement and will be solely responsible for their supervision, daily direction and control, wage rates, withholding income taxes, disability benefits, or the manner and means through which the work under this Agreement will be accomplished.</li>

                                    <li>If any provision of this Agreement is deemed to create a franchise relationship between the parties, then NODWIN may terminate this Agreement and amend any terms and conditions of this Agreement so as to effect the Parties' original intent as closely as possible in order that the transactions contemplated hereby be consummated as a distribution agreement and not a franchise agreement.</li>

                                    
                                </ol>




                                <h4 style={{marginTop:'20px',fontSize:'16px'}}>
                                C) Obligations of Reseller.  
                                 
                                </h4>

                                <ol  style={{fontSize: '10pt',marginTop:'10px'}}>
                                    
                                    <li>Maintaining Facilities and Inventory (Applicable for physical products): Reseller shall, in good faith and at its own expense:	</li>

                                    
                                <ol type="i"  style={{fontSize: '10pt',marginTop:'10px'}}>
                                    
                                    <li>Maintain a place or places of business in the Territory, including adequate office and all other facilities as required for Reseller to perform its duties under this Agreement </li>
                                    <li>Purchase and maintain a representative quantity of each Product sufficient for and consistent with the Reseller's Customers' and Retailers’ sales needs.  </li>
                                    <li>Maintain adequate insurance over the Product, its operations and facilities in order to replace the Product and maintain its business operations in the event of theft, accident or destruction;</li>
                                    <li>Maintain the Product free of any liens, security interests or other encumbrances unless specifically allowed in writing by NODWIN.  </li>
                                    <li>Physically house the Product in a safe, secure and clean space where the Goods are reasonably secure from theft or damage. </li>
                                    

                                    
                                </ol>

                                <li>Marketing and Selling Goods: Reseller shall, in good faith and at its own expense market, advertise, promote and sell the Product to Customers and Retailers located in the Territory consistent with good business practice, in each case using commercially reasonable efforts to maximize the sales volume of the Product and comply with the following:</li>


                                <ol type="i"  style={{fontSize: '10pt',marginTop:'10px'}}>
                                    
                                    <li>Establish and maintain a sales and marketing organization sufficient to develop the market potential for the sale of the Product and a distribution organization and facilities sufficient to make the Product available for shipment (Applicable for physical products) by Reseller to each Customer and Retailer immediately on receipt of order;</li>
                                    <li>Obtain NODWIN’s prior written approval of marketing materials to be used within the Territory to ensure they are consistent with NODWIN’s marketing direction.</li>
                                    <li>Only resell or offer to resell the Product that Reseller currently has in inventory or that have been ordered from the Platform/NODWIN and which order has been accepted by NODWIN as available for delivery to Reseller, unless Reseller has received prior written authorization from NODWIN;</li>
                                    <li>Observe all directions and instructions given to it by NODWIN in relation to the marketing, advertisement and promotion of the Product;</li>
                                    <li>Market, advertise, promote and resell the Product and conduct business in a manner that reflects favorably at all times in the Goods and the good name, goodwill and reputation of NODWIN;</li>
                                    <li>Promptly notify NODWIN of any complaint or adverse claims about any Product or its use of which Reseller becomes aware;</li>
                                    <li>Not distribute counterfeit versions of the Product or products intended to confuse customers as to their authenticity and promptly notify NODWIN if it becomes aware of such products; </li>
                                  
                                </ol>



                                <li>Reporting and Recordkeeping: Reseller shall, at its own expense:</li>

                                <ol type="i"  style={{fontSize: '10pt',marginTop:'10px'}}>
                                    
                                    <li>Wthin 10 days after the end of each calendar month, submit to NODWIN complete and accurate reports of the number of sales to Customers and Retailers, contact information for Retailers receiving the Product and the number of returned units processed by Reseller and/or Retailers</li>
                                    <li>Maintain books, records and accounts of all transactions and activities covered by this Agreement and permit full examination thereof by NODWIN and its representatives. </li>
                                    
                                    

                                    
                                </ol>


                                 <li>Authority to Perform Under this Agreement: Reseller shall, at its own expense, obtain and maintain required certifications, credentials, licenses and permits necessary for the Reseller to conduct business in accordance with this Agreement</li>

                                 


                                <li>Government Approval. If at any time during the Term any notification, registration or approval is required for giving legal effect in any applicable jurisdiction to this Agreement or the transactions contemplated under this Agreement, Reseller shall:</li>

                                <ol type="i"  style={{fontSize: '10pt',marginTop:'10px'}}>
                                    
                                    <li>Immediately take whatever steps may be necessary to properly notify, register or obtain approval;</li>
                                    <li>Be responsible for any charges incurred in connection with notifying, registering or obtaining this approval; </li>
                                    <li>Keep NODWIN informed and updated of its efforts regarding this Section;</li>
             
                                </ol>

                                 <li>Prohibited Acts: Notwithstanding anything to the contrary in this Agreement, neither Reseller nor its personnel shall:</li>

                                <ol type="i"  style={{fontSize: '10pt',marginTop:'10px'}}>
                        
                                    <li>Engage in any unfair, competitive, misleading or deceptive practices respecting NODWIN, NODWIN's intellectual property or the Product, including any product disparagement or "bait-and-switch" practices;  </li>
                                    <li>Separate any software or accessories sold, bundled or packaged with any Product or sell, license or distribute the software on a standalone basis, or remove, translate or modify the contents or documentation of or related to the software or accessories, including, without limitation, any end user license agreements or warranty statements;</li>
                                    <li>Market or distribute the Product other than in the form and packaging as delivered by NODWIN to Reseller under this Agreement;</li>
                                    <li>Sell or offer to sell the Product outside the Territory;</li>
                                    <li>During the Term manufacture, promote, market, sell or distribute the Product using promotional information and material, unless the promotional information or material was provided or approved by NODWIN;</li>
                                    <li>Provide any discounts, offers and/or prices to Customers and Retailers that have not been approved by NODWIN in writing (emails permitted).</li>
                              
                                </ol>
 
                                </ol>


                                <h4 style={{marginTop:'20px',fontSize:'16px'}}>
                                D) Purchase Orders Procedure.
                                 
                                </h4>

                                <ol  style={{fontSize: '10pt',marginTop:'10px'}}>
                                    <li>Purchase Forecasts: Reseller shall provide NODWIN with a rolling forecast of such number of months as specified in the Online Form, for the purchase of the Product.</li>

                                    <li>Purchase Order: Reseller shall issue purchase orders to NODWIN through e-mail, in amounts consistent with its forecast.  If Reseller submits purchase orders in amounts exceeding its forecast, NODWIN shall use commercially reasonable efforts to supply such units of the Product to Reseller in a timely manner. By placing a purchase order, Reseller makes an offer to purchase the Product under the terms and conditions of this Agreement. </li>

                                    <li>NODWIN's Right to Accept or Reject Purchase Orders: NODWIN may, in its sole discretion, accept or reject any purchase order. NODWIN may accept any purchase order by confirming the order. No purchase order is binding on NODWIN unless accepted by NODWIN as provided in this Agreement.</li>
                                    <li>Cancellation of Purchase Orders: NODWIN may without liability or penalty, cancel any purchase order placed by Reseller and accepted by NODWIN, in whole or in part:</li>


                                    <ol type="i"  style={{fontSize: '10pt',marginTop:'10px'}}>
                                    
                                    <li>If NODWIN discontinues its sale of the Product</li>
                                    <li>If NODWIN discontinues the sale of any digital voucher codes or epins or any similar products; </li>
                                    <li>If NODWIN plans to discontinue the Platform  </li>
                                    <li>iv.	if NODWIN determines that Reseller is in material breach of this Agreement.  </li>
             
                                  </ol>
                                   

                                    
                                </ol>


                                
                                <h4 style={{marginTop:'20px',fontSize:'16px'}}>
                                E) Shipment and Delivery.
                                 
                                </h4>

                                <ol  style={{fontSize: '10pt',marginTop:'10px'}}>
                                    <li>Transfer, Title and Risk of Loss:  NODWIN will provide the Reseller with an access to the Online Form through the epin panel (https://www.nodw.in/login) developed by NODWIN (“Epin Panel”). The Reseller will be able to purchase the Product from the Epin Panel upon the advance payment. The Reseller needs to ensure that the Reseller maintains a minimum wallet balance of an amount specified in the Online Form (“Minimum Wallet Balance”).  Ownership and possession of the Product shall transfer to the Reseller upon loading of the Product on the Epin Panel and completion of the payment.  </li>

                                    <li>Refund of Minimum Wallet Balance: NODWIN will refund to the Reseller the unutilized Minimum Wallet Balance post deduction of any dues payable by the Reseller to NODWIN, upon the termination of this Agreement/termination of the association and engagement with the Reseller.   </li>

                                    <li>Validity period:  For situations where the Customer is unable to redeem the Product, Reseller (and its Retailers) shall approach and notify NODWIN’s online customer support center regarding the same and NODWIN will attempt to replace the Product.  If the Product is still within NODWIN’s standard validity/redeemable period for the Territory, NODWIN will as per the Brand's resolution and direction, either replace the Product from its inventory or return the purchase price to the Reseller or its Retailers (as applicable) who shall further return the purchase price to the Customer, consistent with its Refund Policy. NODWIN’s standard validity/redeemable period for the Product is one year from the original date of purchase by the Reseller/Customer, however, the same shall not be valid for all product(s) and may be different for different product(s) as per the applicability and Brand’s discretion. The Parties shall cooperate to develop a tracking mechanism (serial numbers) for identifying the validity period for the Product and the location of purchase (Reseller or Retailers).   </li>

                                    
                                </ol>


                                
                                
                                <h4 style={{marginTop:'20px',fontSize:'16px'}}>
                                F) Price and Payment
                                 
                                </h4>

                                <ol  style={{fontSize: '10pt',marginTop:'10px'}}>
                                    <li>Pricing for the Product is as set forth on the Online Form as per the commercial terms agreed between the Parties in the Online Form. Unless NODWIN has agreed to credit terms with Reseller as identified in the Online Form, Reseller shall pay NODWIN all amounts due to NODWIN as per the invoices provided by NODWIN, prior to shipment, delivery and/or transfer of the Product. All prices are exclusive of statutory taxes, arising as a result of or in connection with the transactions contemplated under this Agreement. Any such sales, use, VAT, excise or other transactional taxes, if any are owed, shall be the responsibility of Reseller. </li>

                               
                                </ol>

                                <h4 style={{marginTop:'20px',fontSize:'16px'}}>
                                G) Resale of the Goods
                                 
                                </h4>

                                <ol  style={{fontSize: '10pt',marginTop:'10px'}}>
                                    <li>Credit Risk on Resale to Customers and Retailers: Reseller is responsible for all credit risks and for collecting payment for the Product sold to Customers, Retailers and/or any other third parties as per the Agreement. The inability of Reseller to collect the purchase price for any Product does not affect Reseller's obligation to pay NODWIN for such Product which shall remain payable by the Reseller as per the invoices shared by NODWIN. </li>

                                    <li>Resale Prices: Reseller unilaterally establishes its own resale prices and terms regarding products it sells, including the Product, however, the Reseller shall not be permitted and/or entitled to sell any Product at a price lower than the purchase price availed by it from NODWIN.</li>
                                    

                               
                                </ol>


                                <h4 style={{marginTop:'20px',fontSize:'16px'}}>
                                H) Licenses
                                 
                                </h4>

                                <ol  style={{fontSize: '10pt',marginTop:'10px'}}>
                                    <li>License for Reseller to Use NODWIN Trademarks:  NODWIN hereby grants to Reseller a royalty-free, fully paid up license, during the Term, to use, publicly display and reproduce NODWIN’s trademarks, including logos set forth in, and in accordance with, NODWIN’s branding guidelines provided as part of the Online Form (the “NODWIN Marks) in marketing and promotional materials for the Product. NODWIN shall have the right to review and approve at each instance, any particular use of the NODWIN Marks prior to that use by the Reseller, provided that (a) such approval shall not be unreasonably withheld, and (b) any previously approved use shall not require a new approval merely because the NODWIN Mark is being used in the form approved in connection with translated versions of the same materials for which that prior approval was obtained.</li>

                                    <li>License to Translated Marketing Materials and Other Documentation: To the extent that Reseller translates or causes to be translated, any of NODWIN's marketing materials, user manuals or other documentation, Reseller hereby irrevocably assigns all copyrights in the translations to NODWIN, subject to a non-exclusive, non-transferable and non-sublicensable license to Reseller, hereby granted by NODWIN, to use the translations in the Territory during the Term solely on or in connection with the promotion, advertising, resale or use of the Product permitted under this Agreement.</li>

                                    <li>NODWIN's Trademark Notices: Reseller shall ensure that the Product sold by Reseller and all related quotations, specifications and descriptive literature, and all other materials carrying NODWIN's Mark, are marked with the appropriate trademark notices in accordance with NODWIN's instructions as set forth in the branding guidelines. </li>

                                    <li>No Continuing Rights: On expiration or termination of this Agreement unless otherwise agreed in writing by the parties, Reseller shall immediately cease all display, advertising, promotion and use of all of the NODWIN Marks and shall not thereafter use, advertise, promote or display any trademark, trade name or product designation or any part thereof that is similar to or confusing with the NODWIN Marks or with any trademark, trade name or product designation associated with NODWIN or the Product.</li>
                                    

                               
                                </ol>



                                

                                <h4 style={{marginTop:'20px',fontSize:'16px'}}>
                                I) Audit Rights. 
                                 
                                </h4>

                                <ol  style={{fontSize: '10pt',marginTop:'10px'}}>
                                    <li>Records Audit:  On reasonable request during the Term and within one year after the expiration or earlier termination of this Agreement, NODWIN may audit Reseller's files relating to its sales, marketing, inventory and returns of the Product. NODWIN may conduct the audit or may retain an auditor to inspect Reseller’s books and records, in strict confidence. NODWIN shall have the right to conduct such an audit once per year upon thirty (30) days advance notice in writing at any time.</li>


                               
                                </ol>


                                <h4 style={{marginTop:'20px',fontSize:'16px'}}>
                                J) Term and Termination 
                                 
                                </h4>

                                <ol  style={{fontSize: '10pt',marginTop:'10px'}}>
                                    <li>Term:  This Agreement will commence on the Effective Date and will be valid for a period of one year (the “Initial Term”), unless terminated earlier by NODWIN as per the Agreement.  Upon expiry of the Term, the Agreement shall auto-renew for a further period which shall be the same period as the Initial Term, unless otherwise terminated earlier as per the sole discretion of NODWIN. NODWIN may terminate this Agreement with a thirty (30) days’ prior written notice (emails permitted) if the Reseller breaches any terms and conditions of the Agreement and fails to cure that breach within two (2) days of being notified of the same (“Cure Period”), if such breach is curable, as per the sole discretion of NODWIN. NODWIN may terminate this Agreement for convenience with a sixty (60) days’ prior written notice (emails permitted). Reseller’s obligations to make purchases and payments hereunder shall survive any termination.  </li>

                                    <li>Effect of Expiration or Termination: Expiration or notice of termination under this Agreement automatically operates as a cancellation of any order from and/or transfer to Reseller of the Product that has been requested by Reseller whether or not accepted by NODWIN. To the extent it is not feasible to cancel the delivery of the Product in the process of shipment (Applicable for physical products), the Product shall be delivered to Reseller’s distribution center, provided Reseller has paid for the Product. Any and all payments due to NODWIN by the Reseller for any Product already ordered by the Reseller shall remain payable by the Reseller even upon expiry or termination of the Agreement.</li>


                                    <li>On the expiration or earlier termination of this Agreement, Reseller shall promptly:</li>

                                    <ol type="i"  style={{fontSize: '10pt',marginTop:'10px'}}>
                                    
                                    <li>Cease to represent itself as NODWIN's authorized Reseller regarding the Product, and shall otherwise desist from all conduct or representations that might lead the public to believe that Reseller is authorized by NODWIN to sell the Product;</li>
                                    <li>Return to NODWIN or verify that it has destroyed all documents, tangible and intangible materials (e.g. computer records) containing, reflecting, incorporating or based on NODWIN's Confidential Information; </li>
                                   
                                  </ol>


                                    <li>In the case of a Party terminating this Agreement, or in the case of the expiration of this Agreement, a Party shall not be liable to the other Party for any damage (whether direct or indirect) incurred by the other Party solely arising from the expiration or earlier termination of this Agreement</li>



                               
                                </ol>


                                <h4 style={{marginTop:'20px',fontSize:'16px'}}>
                                K) Warranties; Disclaimer. 
                                 
                                </h4>

                                <ol  style={{fontSize: '10pt',marginTop:'10px'}}>
                                    <li>Mutual Warranties:  The Parties each represent and warrant that (1) it is a business entity duly organized, validly existing and in good standing in the jurisdiction of its incorporation; (2) it is duly qualified to do business and is in good standing in every jurisdiction in which such qualification is required; (3) when executed and delivered by each Party, this Agreement will constitute the legal, valid and binding obligation of each Party.</li>

                                    <li>Reseller Warranties:  Reseller represents, warrants and covenants that (1) it will comply with all applicable laws and retain all applicable licenses for its marketing, promotion, sale and distribution of the Product; (2) it will not make any of its own representations, warranties or claims about the Product; and (3) it will not alter or reproduce any NODWIN end-user documentation or other information provided by NODWIN regarding the Product except as expressly approved by NODWIN; and (4) to the best of its knowledge, the Reseller’s intellectual property including its trademarks, do not violate or infringe any third party intellectual property rights in the Territory. </li>

                                    <li>3.	Disclaimer of Warranties: EXCEPT FOR THOSE WARRANTIES EXPRESSLY PROVIDED IN THIS AGREEMENT, AND AS BETWEEN NODWIN AND RESELLER, TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, EACH PARTY DISCLAIMS ANY AND ALL WARRANTIES, EXPRESS, IMPLIED OR STATUTORY, IN CONNECTION WITH THE PRODUCT AND ANY OTHER ITEMS PROVIDED OR MADE AVAILABLE BY NODWIN UNDER THIS AGREEMENT, INCLUDING IMPLIED WARRANTIES OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE.</li>


                               
                                </ol>



                                    
                                <h4 style={{marginTop:'20px',fontSize:'16px'}}>
                                L) Dispute Resolution for Customers
                                 
                                </h4>

                                <ol  style={{fontSize: '10pt',marginTop:'10px'}}>
                                    
                                    <li>

                                    <p>The Reseller agrees to follow and shall ensure that the Customer follows the dispute resolution process mentioned hereunder:</p>
                                   

                                    In the event that the Product is not redeemable or functioning, the Customer shall  reach out to NODWIN  at epinsupport@nodwin.com within 24 hours of discovering the defect in the Product. NODWIN will first verify that the Product is still within its validity and redeemable period which is 1 year from the date of purchase of the Product by the Customer, unless stated otherwise on the Portal for the Product. Upon confirming that the Product is still within its validity and redeemable period, NODWIN will further initiate an investigation into the issue with the Customer’s Product. If the investigation confirms that the Product is indeed faulty and/or not working as intended, NODWIN shall ask the Reseller to provide the Customer with a replacement of the Product (“Replacement”). The Reseller shall provide NODWIN with the Replacement and NODWIN shall further proceed with replacing the Product for the Customer. The Reseller shall provide NODWIN with the Replacement within 2 days of NODWIN notifying the Reseller of the same. 
                                    </li>



                               
                                </ol>


                                <h4 style={{marginTop:'20px',fontSize:'16px'}}>
                                M) Indemnity Obligations
                                 
                                </h4>

                                <ol  style={{fontSize: '10pt',marginTop:'10px'}}>
                                    
                                    <li>Reseller will defend, indemnify and hold NODWIN harmless against any claims, losses, damages or costs (including legal costs) and pay the amount of any adverse final judgment (or settlement to which NODWIN consents).  Reseller’s obligations are subject to the following conditions: (i) NODWIN will promptly notify Reseller in writing of the claim; (ii) NODWIN will, at its own cost and expense, reasonably cooperate with Reseller in the defense of the claim; and (iii) Reseller will have sole control over the defense and settlement of the claim, but will not settle the claim without NODWIN’s prior written consent, such consent not to be unreasonably withheld.</li>

                                    <li>Should any claim, demand, action or other legal proceeding arising out of subject matter covered by this Agreement be made or instituted by any third party against a Party to this Agreement or if a Party is made a party to a third party dispute by the other Party, the other Party to this Agreement shall furnish such information and reasonable assistance in defending such proceeding as may be reasonably requested by the Party against whom such proceeding is brought. The requesting Party shall pay all expenses incurred by the other Party in complying with any such request.</li>




                               
                                </ol>


                                <h4 style={{marginTop:'20px',fontSize:'16px'}}>
                                N) Governing Law and Jurisdiction
                                 
                                </h4>

                                <ol  style={{fontSize: '10pt',marginTop:'10px'}}>
                                    
                                    <li>This Agreement will be governed by and construed in accordance with the laws of the India, and any dispute arising under, in connection with, or incident to this Agreement or concerning its interpretation will be resolved exclusively in courts at Gurugram, Haryana and the Parties irrevocably consent to the exclusive exercise of jurisdiction by said courts.</li>

                                </ol>


                                <h4 style={{marginTop:'20px',fontSize:'16px'}}>
                                O) General {role}
                                 
                                </h4>

                                <ol  style={{fontSize: '10pt',marginTop:'10px'}}>
                                    
                                    <li>Confidentiality: The Parties mutually agree that any and all confidential information disclosed during the course of their business relationship, including but not limited to proprietary technology, trade secrets, financial data, and customer information, shall be held in strict confidence and used solely for the purpose of fulfilling their obligations under the Agreement. Both Parties shall take reasonable measures to safeguard the confidentiality of such information, including implementing appropriate security measures and restricting access to authorized personnel only. This confidentiality obligation shall survive the termination or expiration of this Agreement and shall remain in effect indefinitely, unless otherwise agreed in writing by both Parties. Notwithstanding the foregoing, confidential information shall not include information that: (a) is or becomes publicly available through no fault of the Receiving Party (the Party receiving the confidential information); (b) was rightfully in the receiving Party's possession prior to disclosure by the Disclosing Party (the Party disclosing the confidential information); (c) is independently developed by the Receiving Party without reference to the Disclosing Party's confidential information; or (d) is rightfully obtained by the Receiving Party from a third party without restriction on disclosure. In the event of any breach or threatened breach of this confidentiality clause, the non-breaching Party shall be entitled to seek injunctive relief and any other remedies available at law or in equity.</li>
                                    <li>Assignment: Neither Party may assign this Agreement or its rights hereunder without the other Party’s prior written consent, except that NODWIN may assign, partially assign, or sublicense some or all of, its rights under this Agreement to any of its affiliates and/or sister concerns.</li>
                                    <li>Waiver:  No waiver of any provision of this Agreement will be effective unless it is in a signed writing, and no such waiver will constitute a waiver of any other provision(s) or of the same provision on another occasion</li>
                                    <li>Cumulative Remedies:  The rights and remedies under this Agreement are cumulative and are not exclusive of any rights or remedies available at law or in equity or by any other agreement between the Parties.</li>
                                    <li>Severability:  If a court of competent jurisdiction holds any term, covenant or restriction of this Agreement to be illegal, invalid or unenforceable, in whole or in part, the remaining terms, covenants and provisions will remain in full force and effect and will in no way be affected, impaired or invalidated.  If any provision in this Agreement is determined to be unenforceable in equity because of its scope, duration, geographical area or other factor, then the court making that determination will have the power to reduce or limit such scope, duration, area or other factor, and such provision will be then enforceable in equity in its reduced or limited form.</li>
                                    <li>Notice: Any notice required or permitted under the terms of this Agreement or required by law must be in writing and must be: delivered in person, sent by first class registered mail, or air mail, or email, as appropriate, or sent by overnight air courier, in each case properly posted and fully prepaid to the appropriate address as set forth below (for NODWIN) and set forth in the Online Form (for Reseller).  Either party may change its address for notices by notice to the other party given in accordance with this Section. Notices will be deemed given at the time of actual delivery in person, three business days after deposit in the mail as set forth above, or one day after delivery to an overnight air courier service.</li>
                                    <li>Modifications and updates: NODWIN may amend, modify and/or update the Agreement and any terms and conditions thereof from time to time. The Reseller shall be required to check the date mentioned in “Latest update on” at the beginning of the Agreement to stay updated with the latest version of the Agreement. </li>
                                    

                                </ol>

                     


        <ol style={{ fontSize: '14pt', marginTop: '10px' }}>
        <li>
          Territory - {isEditing ? (
            <div className="form-group">
            <input
              type="text"
              name="territory"
              value={formData.territory}
              onChange={handleInputChange}
            />
            </div>
          ) : (
            agreeData.territory
          )}
        </li>
        <li>
          Exclusivity (if applicable) - {isEditing ? (
            <div className="form-group">
            <input
              type="text"
              name="exclusive"
              value={formData.exclusive}
              onChange={handleInputChange}
            />
            </div>
          ) : (
            agreeData.exclusive
          )}
        </li>
        <li>
          Minimum Wallet Balance - {isEditing ? (
              <div className="form-group">
            <input
              type="text"
              name="minWallet"
              value={formData.minWallet}
              onChange={handleInputChange}
            />
            </div>
          ) : (
            agreeData.minWallet
          )}
        </li>
        <li>
          Validity Period - {isEditing ? (
            <div className="form-group">
            <input
              type="text"
              name="validityPeriod"
              value={formData.validityPeriod}
              onChange={handleInputChange}
            />
            </div>
          ) : (
            agreeData.validityPeriod
          )}
        </li>
        <li>
          Rolling Forecast - {isEditing ? (
            <div className="form-group">
            <input
              type="text"
              name="rollForecast"
              value={formData.rollForecast}
              onChange={handleInputChange}
            />
            </div>
          ) : (
            formData.rollForecast
          )}
        </li>
        <li>
          Specific/Additional Terms (if any) - {isEditing ? (
            <div className="form-group">
            <input
              type="text"
              name="additionalItem"
              value={formData.additionalItem}
              onChange={handleInputChange}
            />
            </div>
          ) : (
            agreeData.additionalItem
          )}
        </li>
      </ol>

      
     




















                                
                           
                               
                           
                            

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )


}
export default MerchantAgreementView;
